import Vue from 'vue'
import Router from 'vue-router'
import Routes from './routes'

import Session from '@/components/general/session/session'
import HTTP from '@/components/general/http/http'

import Login from '@/components/public/login/login'
import Private from '@/components/private/private'
import Sellers from '@/components/private/sellers/sellers'
import SellersList from '@/components/private/sellers/list/list'
import SellersDelegations from '@/components/private/sellers/delegations/delegations'
import SellersTypes from '@/components/private/sellers/sellers-types/sellers-types'
import Clients from '@/components/private/clients/clients'
import ClientsList from '@/components/private/clients/list/list'
import ClientsRecords from '@/components/private/clients-records/clients-records'
import ClientsRecordsList from '@/components/private/clients-records/list/list'
import Contracts from '@/components/private/contracts/contracts'
import ContractsList from '@/components/private/contracts/list/list'
import ContractsSDA from '@/components/private/contracts/sda/sda'
import ContractsZips from '@/components/private/contracts/zips/zips'
import Reports from '@/components/private/reports/reports'
import ReportsMasterData from '@/components/private/reports/master-data/master-data'
import ReportsSDA from '@/components/private/reports/sda/sda'
import ReportsPotential from '@/components/private/reports/potential/potential'
import ReportsCCI from '@/components/private/reports/cci/cci'
import ReportsEducation from '@/components/private/reports/education/education'
import History from '@/components/private/history/history'
import HistoryContracts from '@/components/private/history/contracts/contracts'
import HistorySDA from '@/components/private/history/sda/sda'

Vue.use(Router)

let RouterToExport = new Router({
  mode: 'history',
  routes: [
    {
      path: Routes.login.path,
      name: Routes.login.name,
      component: Login
    },
    {
      path: Routes.private.path,
      name: Routes.private.name,
      component: Private,
      children: [
        {
          path: Routes.sellers.path,
          name: Routes.sellers.name,
          component: Sellers,
          children: [
            {
              path: Routes.sellersList.path,
              name: Routes.sellersList.name,
              component: SellersList
            },
            {
              path: Routes.sellersDelegations.path,
              name: Routes.sellersDelegations.name,
              component: SellersDelegations
            },
            {
              path: Routes.sellersTypes.path,
              name: Routes.sellersTypes.name,
              component: SellersTypes
            }
          ]
        },
        {
          path: Routes.clients.path,
          name: Routes.clients.name,
          component: Clients,
          children: [
            {
              path: Routes.clientsList.path,
              name: Routes.clientsList.name,
              component: ClientsList
            }
          ]
        },
        {
          path: Routes.clientsRecords.path,
          name: Routes.clientsRecords.name,
          component: ClientsRecords,
          children: [
            {
              path: Routes.clientsRecordsList.path,
              name: Routes.clientsRecordsList.name,
              component: ClientsRecordsList
            }
          ]
        },
        {
          path: Routes.contracts.path,
          name: Routes.contracts.name,
          component: Contracts,
          children: [
            {
              path: Routes.contractsList.path,
              name: Routes.contractsList.name,
              component: ContractsList
            },
            {
              path: Routes.contractsSDA.path,
              name: Routes.contractsSDA.name,
              component: ContractsSDA
            },
            {
              path: Routes.contractsZips.path,
              name: Routes.contractsZips.name,
              component: ContractsZips
            }
          ]
        },
        {
          path: Routes.reports.path,
          name: Routes.reports.name,
          component: Reports,
          children: [
            {
              path: Routes.reportsMasterData.path,
              name: Routes.reportsMasterData.name,
              component: ReportsMasterData
            },
            {
              path: Routes.reportsSDA.path,
              name: Routes.reportsSDA.name,
              component: ReportsSDA
            },
            {
              path: Routes.reportsPotential.path,
              name: Routes.reportsPotential.name,
              component: ReportsPotential
            },
            {
              path: Routes.reportsCCI.path,
              name: Routes.reportsCCI.name,
              component: ReportsCCI
            },
            {
              path: Routes.reportsEducation.path,
              name: Routes.reportsEducation.name,
              component: ReportsEducation
            }
          ]
        },
        {
          path: Routes.history.path,
          name: Routes.history.name,
          component: History,
          children: [
            {
              path: Routes.historyContracts.path,
              name: Routes.historyContracts.name,
              component: HistoryContracts
            },
            {
              path: Routes.historyContractsSDA.path,
              name: Routes.historyContractsSDA.name,
              component: HistorySDA
            },
          ]
        },
      ]
    }
  ]
})

RouterToExport.beforeEach((to, from, next) => {

  if (to.name.indexOf('private') != -1) {

    if (!localStorage.getItem('sessionToken')) {

      return next({name: Routes.login.name})

    }

    HTTP.setHeader({key: 'x-parse-session-token', value: localStorage.getItem('sessionToken')})

    return Session
      .fetchSession()
      .then((response) => {

        if (!response.success) {

          return next({name: Routes.login.name})

        }

        return next()

      })

  }

  return next()

})

export default RouterToExport



// WEBPACK FOOTER //
// ./src/router/index.js